<template>
  <div>
    <h1>{{ $route.meta.title }}</h1>
    <b-form @submit.stop.prevent="save">
      <b-form-group id="form-email-group" label="Email addres:" label-for="form-text-email">
        <b-input type="email" id="form-text-email" disabled :value="user.details.email"></b-input>
      </b-form-group>

      <b-form-group id="form-displayName-group" label="Name:" label-for="form-text-displayName">
        <b-input
          type="text"
          id="form-text-displayName"
          required
          :value="user.details.displayName"
          @input="updateLocalState"
        ></b-input>
      </b-form-group>
      <b-button type="submit" variant="primary">Save</b-button>
    </b-form>
    <b-alert :show="!!error" variant="warning">{{ error }}</b-alert>

    <dropbox-auth></dropbox-auth>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DropboxAuth from "@/components/DropboxAuth.vue";
import fb from "@/firebaseConfig";

export default {
  components: {
    "dropbox-auth": DropboxAuth
  },
  data() {
    return {
      name: "",
      error: ""
    };
  },
  methods: {
    save() {
      const name = this.name ? this.name : this.user.details.displayName;
      fb.db
        .collection("users")
        .doc(this.user.details.uid)
        .update({ name })
        .then(() => {})
        .catch(err => {
          this.error = err;
          setTimeout(() => (this.error = ""), 3000);
        });
    },
    updateLocalState(value) {
      this.name = value;
    }
  },
  computed: {
    ...mapGetters({ user: "user/user" })
  }
};
</script>

<style lang="scss" scoped></style>
